export const authors = {
    "benoit": {"name": "B. Lange", "url": "https://orcid.org/0009-0007-7820-8249"},
    "nancy": {"name": "N. Rodriguez", "url": "https://orcid.org/0000-0002-5496-1603"},
    "william": {"name": "W. Puech", "url": "https://orcid.org/0000-0001-9383-2401"},
    "florent": {"name": "F. Masseglia", "url": "https://orcid.org/0000-0002-1149-585X"},
    "reza": {"name": "R. Akbarinia", "url": "https://orcid.org/0000-0003-0372-0241"},
    "ines": {"name": "I. Di Loreto", "url": "https://orcid.org/0000-0002-4710-7521"},
    "pierre": {"name": "P. Fortin", "url": "https://orcid.org/0000-0003-3117-9122"},
    "vincent": {"name": "V. Berry", "url": "https://orcid.org/0000-0001-7271-4027"},
    "chouki": {"name": "C. Tibermacine", "url": "https://orcid.org/0000-0002-2063-0291"},
    "arnaud-castelltort": {"name": "A. Castelltort", "url": "https://orcid.org/0000-0002-0305-2231"},
    "Teriihoania": {"name": "J. Teriihoania", "url": ""},
    "Trubiani": {"name": "C. Trubiani", "url": "https://orcid.org/0000-0002-7675-6942"},
    "lucie": {"name": "L. Collineau", "url": "https://orcid.org/0000-0001-6221-0765"},
    "Lacmago": {"name": "L. Lacmago", "url": ""},
    "Lacotte": {"name": "Y. Lacotte", "url": "https://orcid.org/0000-0002-8282-9327"},
    "Lemenand": {"name": "O. Lemenand", "url": ""},
    "Chauvin": {"name": "C. Chauvin", "url": "https://orcid.org/0000-0003-4837-4418"},
    "toan": {"name": "T. Nguyen", "url": ""},
    "xavier": {"name": "X. Vasques", "url": "https://orcid.org/0000-0002-9322-1974"},
    "sebastien-andary": {"name": "S. Andary", "url": ""},
    "william-dyce": {"name": "W. Dyce", "url": ""},
    "antoine": {"name": "A. Seilles", "url": ""},
    "herve": {"name": "H. Rey", "url": ""},
    "dennis": {"name": "D. Shasha", "url": "https://orcid.org/0000-0002-7036-3312"},
    "guillaume": {"name": "G. Coulaud", "url": ""},
    "audrey": {"name": "A. Brouillet", "url": ""},
    "rebecca": {"name": "R. Salles", "url": "https://orcid.org/0000-0002-1001-3839"},
    "Eduardo": {"name": "E. Ogasawara", "url": ""},
    "esther": {"name": "E. Pacitti", "url": "https://orcid.org/0000-0003-1370-9943"},
}
